import * as React from 'react';
import { LabelConfig } from 'ui';
import { Icon } from 'ui/common/icon';
import styles from './tab-item.scss';
import { tabIconForDomain } from './tab-icon';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { insertOptionalWordbreaks } from 'app/infrastructure/platform';

export interface TabItemProps{
  /**
   * The *domain* id of the tab item's section represention
   */
  id: number;
  /**
   * Tab display text. Output is limited to 30 rendered characters
   */
  label: LabelConfig;
  /**
   * True if the tab has selected active styling
   */
  active: boolean;
  /**
   * When false, invalid styling is applied
   */
  valid: boolean;
  /**
   * When true, one or more components inside the tab has warnings attached
   */
  warnings?: boolean;
  /**
   * Url to set as location when selected
   */
  url: string;
  /**
   * Relative url to icon
   */
  iconUrl?: string;
  /**
   * When false null will be rendered
   */
  visible: boolean;
  onClick: (e: React.MouseEvent<any>)=>void;
}

export const TabItem: React.SFC<TabItemProps> = props => {
  const {
    id,
    label,
    active,
    valid,
    warnings,
    url,
    iconUrl,
    onClick,
    visible
  } = props;

  const activeTab = active && valid !== false && warnings !== true ? 'active':'';
  const invalidTab = valid === false ? styles.invalidTab : (warnings === true ? styles.warningTab : '');
  const tabIndex = active ? -1 : 0;
  const urlToIcon = iconUrl ? toAbsoluteUrl(iconUrl) : tabIconForDomain(id);

  return  visible ? <li key={`${id}`} id={`tab-${id}`}>
              <a href={url} onClick={onClick} className={`${styles.tabItem} ${activeTab} ${invalidTab}`}
                tabIndex={tabIndex} role="tab" aria-selected={active}>
                  <div className={styles.iconWrapper}><Icon url={urlToIcon}/></div>
                  <span>{ insertOptionalWordbreaks(label.text) }</span>
              </a>
            </li>
          :
            // when hidden, the correct element type and key must be preserved to retain tab order
            <li key={`${id}`} style={{visibility:'collapse'}}/>;
};
